import { render, staticRenderFns } from "./CommentCreate.vue?vue&type=template&id=9a1f02f4&scoped=true"
import script from "./CommentCreate.vue?vue&type=script&lang=js"
export * from "./CommentCreate.vue?vue&type=script&lang=js"
import style0 from "./CommentCreate.vue?vue&type=style&index=0&id=9a1f02f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1f02f4",
  null
  
)

export default component.exports